<template lang="pug">
  .sales-team
    .background-header.white
      v-container.white.pb-0(style="max-width:600px")
        //- .sticky-header-container(style="top:-1px")
          .sticky-header(:class="{ 'hidden-header': !showHeader }")
        div.my-2.mx-2
          v-text-field(v-model="searchText" :placeholder="$t('search_member')" hide-details dense outlined height="40" background-color="basic200")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div.mx-2
          v-menu(bottom :offset-x='false' :offset-y='true')
            template(v-slot:activator='{ on }')
              v-btn.px-0(color='transparent' text v-on='on' v-if="member.role === 'Admin'")
                eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
                div.info500--text.s1.text-capitalize {{ $t('invite_new_member') }}
            v-list(dense)
              v-list-item(@click="clickInviteMember")
                v-list-item-title
                  v-layout
                    v-icon.my-auto(size="18") mdi-account-plus
                    p.ml-2.my-auto {{ $t('invite') }}
              v-list-item( @click="clickInvitedList")
                v-list-item-title
                  v-layout
                    v-icon.my-auto(size="18") mdi-format-list-bulleted
                    p.ml-2.my-auto {{ $t('invited_list') }}

      v-container.pa-0.main-container(style="max-width: 600px")
        v-tabs(v-model="selectedFilter" fixed-tabs color="textColorAccent" height="44")
          v-tab.button-AA-medium(v-for='filter in filters' :key="filter.text" :style="{'border-bottom':'2px solid '+ $vuetify.theme.themes[$theme].basic600T16 }") {{ filter.text }}

    //- v-container.pa-0(:style="{'max-width':'600px', 'margin-top': !showHeader ? '0' : '55px'}")
    v-container.pa-0.mb-4(style="max-width: 600px")
      v-layout.my-6(v-if="isFetching" style="padding:25px")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else).mx-2
        v-layout.my-6(v-if="members.length == 0" style="padding:25px")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('members_not_found') }}
        .items-layout(v-else)
          template(v-for='(member, index) in members')
            team-item(:parentMember.sync="member" :disableSwitch="reachMemberCountLimit" :key="member.id" @deleted="handleDeleteItem" @check="fetchActiveMemberCount" @updateLocal="updateActiveMember($event)")
            v-divider.basic300
      y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      invite-member(v-if="showInviteMemberDialog" :open.sync="showInviteMemberDialog" :company="company")
      invited-list(v-if="showInvitedListDialog" :open.sync="showInvitedListDialog" :company="company")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import InviteMember from '@/components/dialogs/InviteMember.vue'
import InvitedList from '@/components/dialogs/InvitedList.vue'
import TeamItem from '@/components/TeamItem.vue'

export default {
  name: 'SalesTeam',
  components: { InviteMember, InvitedList, TeamItem },
  props: ['company'],
  data: (vm) => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    showInviteMemberDialog: false,
    showInvitedListDialog: false,
    isTyping: false,
    selectedStyle: 0,
    fetchCount: 10,
    page: 1,
    count: 0,
    members: [],
    searchText: '',
    searchCountDown: null,
    filters: [
      {
        text: vm.$t('all'),
        value: ''
      },
      {
        text: 'Admin',
        value: '1'
      },
      {
        text: 'Sales',
        value: '2'
      },
      {
        text: 'Agent',
        value: '3'
      }
    ],
    selectedFilter: 0,
    roleFilter: '',
    statuses: [],
    activeMemberCount: 0,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
    reachMemberCountLimit () {
      if (this.yezzaSubscription && this.yezzaSubscription.limitations && this.yezzaSubscription.limitations.member) {
        const maxCount = this.yezzaSubscription.limitations.member
        if (maxCount === -1) {
          return false
        }
        if (this.activeMemberCount < maxCount) {
          return false
        }
      }
      return true
    },
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchMembers(1)
    } else {
      this.fetchMembers(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchMembers(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        const filter = this.filters[this.selectedFilter]
        this.searchItem(filter.value)
      }, 500)
    },
    selectedFilter(val) {
      const filter = this.filters[val]
      this.searchItem(filter.value)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchMembers(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/members/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=id&exclude_roles=5`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url)
        .then((response) => {
          this.members = response.data.results
          this.statuses = response.data.results.map(m => m.status === 'active' ? true : false)
          this.fetchActiveMemberCount()
          this.count = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchActiveMemberCount () {
      this.$axios.get(`/companies/${this.company.id}`)
        .then(resp => {
          this.activeMemberCount = resp.data.active_member_count
        })
        .catch(() => {})
    },
    clickInviteMember () {
      if (this.reachMemberCountLimit) {
        this.showMessage(['upgrade'])
        return
      }
      this.showInviteMemberDialog = true
    },
    clickInvitedList () {
      if (this.reachMemberCountLimit) {
        this.showMessage(['upgrade'])
        return
      }
      this.showInvitedListDialog = true
    },
    searchItem (role) {
      var searchUrl = `/members/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&role=${role}&ordering=id&exclude_roles=5`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.members = response.data.results
          this.fetchActiveMemberCount()
          this.count = response.data.count
        }).catch(() => {})
    },
    handleDeleteItem (item) {
      this.members = this.members.filter((x) => x !== item)
    },
    updateActiveMember (val) {
      if (val) {
        this.activeMemberCount++
      } else {
        this.activeMemberCount--
      }
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    },
  }
}
</script>
<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
}
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 100px;
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -100%, 0) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "invite_new_member": "Invite New Member"
  },
  "id": {
    "invite_new_member": "Undang Member Baru"
  }
}
</i18n>